<template>
  <div class="list-box">
    <table>
      <thead>
        <tr>
          <td v-for="(item, index) in config.header" :key="index">
            {{ item }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in tableData" :key="index">
          <td :class="'status' + item.status">{{ item.level }}</td>
          <td :class="'status' + item.status">{{ item.position }}</td>
          <td :class="'status' + item.status">{{ item.content }}</td>
          <td style="text-align: left; padding: 0 10px">
            <p style="margin: 0" v-for="(p, index) in item.plan" :key="index">
              {{ p }}
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errorFlag: false,
      config: {
        header: ["等级", "部件定位", "内容描述", "检修方案"],
        data: [
          {
            level: "正常",
            status: 0,
            position: "绕组",
            content: "/",
            plan: "/",
          },
          {
            level: "正常",
            status: 0,
            position: "传感器触头",
            content: "/",
            plan: "/",
          },
          {
            level: "正常",
            status: 0,
            position: "高压侧电流",
            content: "/",
            plan: "/",
          },
          {
            level: "正常",
            status: 0,
            position: "绕组",
            content: "/",
            plan: "/",
          },
        ],
        dataError: [
          {
            level: "异常",
            status: 2,
            position: "绕组",
            content: "绕组温度过高",
            plan: [
              "1.请检查变压器绕组匝间或层间是否短路",
              "2.请检修分接开关是否接触不良",
              "3.请检查铁芯硅钢片间绝缘是否破坏",
            ],
          },
          {
            level: "警告",
            status: 1,
            position: "传感器",
            content: "pt100数据突变",
            plan: [
              "1.请检查传感器与绕组连接是否正常",
              "2.请检查传感器是否出现故障",
            ],
          },
        ],
      },
    };
  },
  computed: {
    tableData() {
      return this.errorFlag ? this.config.dataError : this.config.data;
    },
  },
};
</script>

<style scoped>
.list-box {
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.list-box > table {
  height: 100%;
  width: 100%;
  text-align: center;
}
.list-box > table tr {
  line-height: 40px;
  background: #28f8ff1f;
}
.list-box > table tr:nth-child(2n-1) {
  line-height: 40px;
  background: #ffffff00;
}
.list-box > table > thead > tr {
  background: #58b0d5a6 !important;
}
</style>
